var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6175 0.383521C41.7992 0.565518 41.9234 0.796891 41.9747 1.0489C42.0261 1.30091 42.0022 1.56244 41.9062 1.80102L26.6313 39.9869C26.4967 40.3232 26.2719 40.6158 25.9817 40.8326C25.6915 41.0494 25.3471 41.1819 24.9865 41.2155C24.6258 41.2492 24.2628 41.1827 23.9375 41.0233C23.6122 40.864 23.3372 40.618 23.1427 40.3124L14.8005 27.2005L1.68858 18.8583C1.38229 18.664 1.13563 18.3888 0.975814 18.0632C0.816 17.7376 0.749245 17.3742 0.782916 17.013C0.816587 16.6519 0.949376 16.3071 1.16663 16.0166C1.38388 15.7261 1.67715 15.5013 2.01408 15.367L40.2 0.097396C40.4385 0.00135325 40.7001 -0.022481 40.9521 0.0288539C41.2041 0.0801889 41.4355 0.204431 41.6175 0.386146V0.383521ZM17.4202 26.434L24.6678 37.8213L37.092 6.76227L17.4202 26.434ZM35.2361 4.9064L4.17708 17.3305L15.567 24.5755L35.2387 4.9064H35.2361Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.4f6941aab9441d8b597d6c1afda97737.svg";
export { ForwardRef as ReactComponent };